import { createContext } from "react";
import type { ReactNode } from "react";

import type { MarketType, StrategySpec } from "@strat/format";

// Its own module, so a host can provide it without importing the Workbench
// itself (and the charting library behind it) into its first bundle.

/**
 * What a host sees of the Workbench, to offer its own actions on it — a
 * hosted service's "run this as a bot", say. `saveStrategy` saves the rules
 * (no backtest run) and resolves with the id they were saved under, which a
 * server may have changed (saving someone else's strategy makes a copy).
 */
export interface WorkbenchHostContext {
  spec: StrategySpec;
  strategyId: string | undefined;
  symbol: string;
  timeframe: string;
  marketType: MarketType;
  initialCapital: number;
  saveStrategy: () => Promise<string>;
}

/**
 * Extra actions a host renders in the Workbench's header and its save card.
 * Unset (the lab, the desktop client): nothing extra is drawn.
 */
export const WorkbenchHostActions = createContext<((ctx: WorkbenchHostContext) => ReactNode) | null>(null);
